import React from 'react'
import UnauthorizedIllustration from './unauthorizedIllustration.svg'
import { Button, Row, Space, Typography } from 'antd'

const UnauthorizedScreen = () => {
  return (
    <section
      style={{
        height: '100%',
        placeItems: 'center',
        display: 'grid',
      }}
    >
      <Space direction="vertical">
        <Row justify={'center'}>
          <img src={UnauthorizedIllustration} alt="Unauthorized" />
        </Row>
        <Row justify={'center'}>
          <Typography.Title
            level={2}
            style={{
              color: 'var(--neutral-300)',
            }}
          >
            We are sorry...
          </Typography.Title>
        </Row>
        <Row justify={'center'}>
          <Typography.Paragraph
            style={{
              textAlign: 'center',
              color: 'var(--neutral-200)',
            }}
          >
            The page you are trying to visit has restricted access. If you think this is an error,
            <br /> kindly drop an email to access@skit.ai
          </Typography.Paragraph>
        </Row>
        <Row justify={'center'}>
          <Button className="skit-primary-btn" type="primary" size="large" href="/">
            Back to Home
          </Button>
        </Row>
      </Space>
    </section>
  )
}

export default UnauthorizedScreen
